"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCBA = exports.revokeCBA = exports.getCBAReducer = void 0;
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var currenciesList_1 = require("common/global/currenciesList");
var projectsList_1 = require("common/global/projectsList");
var usersList_1 = require("common/global/usersList");
var doesObjHaveUndefinedValues_1 = __importDefault(require("common/utils/doesObjHaveUndefinedValues"));
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var app_1 = __importStar(require("firebase/app"));
var lodash_1 = require("lodash");
var set_1 = __importDefault(require("lodash/fp/set"));
var map_1 = __importDefault(require("lodash/map"));
var moment_1 = __importDefault(require("moment"));
var sendApprovalNotification_1 = require("portal/utils/sendApprovalNotification");
var SendNotification_1 = require("portal/utils/SendNotification");
var POReducer_1 = require("../PO/POReducer");
var getCBAReducer = function (router, t) { return function (state, action) {
    var _a, _b, _c, _d;
    var userId = (_b = (_a = (0, app_1.auth)().currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : "";
    switch (action.type) {
        case "init":
            return action.payload;
        case "update":
            if (action.payload.path.endsWith("supplierSelectionNumber")) {
                state = (0, set_1.default)(action.payload.path.replace("supplierSelectionNumber", "selectedSupplierId"), (_c = state.RFQsData[action.payload.newValue - 1]) === null || _c === void 0 ? void 0 : _c.supplierId, state);
                state = (0, set_1.default)(action.payload.path.replace("supplierSelectionNumber", "selectedRFQId"), (_d = state.RFQsData[action.payload.newValue - 1]) === null || _d === void 0 ? void 0 : _d.id, state);
            }
            if (action.payload.path === "CBADate") {
                var date_1 = action.payload.newValue;
                state.RFQsData.forEach(function (rfq) {
                    var isBefore = (0, moment_1.default)(date_1).isBefore(rfq.RFQDate.toDate());
                    date_1 = isBefore ? rfq.RFQDate.toDate() : date_1;
                });
                if (date_1 !== action.payload.newValue) {
                    antd_1.message.error(t("alerts.cbaDateCanNotBeBeforeRfqDate"));
                }
                return (0, set_1.default)(action.payload.path, date_1, state);
            }
            return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
        case "buttonClick":
            switch (action.data.action) {
                case "Save": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            data = getCBADataFromState(state);
                            transaction.update(collectionsRef_1.CBAsRef.doc(state.CBAId), (0, removeUndefined_1.default)(data));
                            state.CBAItems.map(function (CBAItemDoc) {
                                transaction.update(collectionsRef_1.CBAItemsRef.doc(CBAItemDoc.id), (0, removeUndefined_1.default)(CBAItemDoc));
                            });
                            (0, map_1.default)(state.CBARFQItems, function (item) {
                                var _a;
                                var selectedSupplierId = (_a = state.CBAItems.find(function (i) { return i.id === item.CBAItemId; })) === null || _a === void 0 ? void 0 : _a.selectedSupplierId;
                                var itemData = {
                                    technicalEvaluationMark: item.technicalEvaluationMark,
                                    selectedSupplierId: selectedSupplierId,
                                };
                                transaction.update(collectionsRef_1.CBARFQItemsRef.doc(item.id), (0, removeUndefined_1.default)(itemData));
                            });
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    })
                        .catch(function (error) {
                        antd_1.message.error(error);
                    });
                    break;
                }
                case "Approve": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    transaction.set(collectionsRef_1.approvalsRef.doc(), {
                                        approvedAt: action.data.payload.approvedAt,
                                        createdAt: new Date(),
                                        updatedAt: new Date(),
                                        userId: userId,
                                        formId: state.CBAId,
                                        formType: "comparative-bid-analysis",
                                        approvalType: action.data.payload.approvalType,
                                        signatureURL: (_b = (_a = usersList_1.globalUsersData[userId]) === null || _a === void 0 ? void 0 : _a.signatureURL) !== null && _b !== void 0 ? _b : "",
                                    });
                                    return [4 /*yield*/, checkIfAllApproved(state.CBAId, state.orderId, state, userId, action.data.payload.approvalType, transaction)];
                                case 1:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                        //   window.location.reload();
                    });
                    var nextStatus = checkNextStatus(state, action.data.payload.approvalType);
                    return __assign(__assign({}, state), { status: nextStatus });
                    //   break;
                }
                case "Cancel": {
                    collectionsRef_1.CBAsRef.doc(state.CBAId)
                        .update({ status: "cancelled" })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: (_a = state.RFQsData[0]) === null || _a === void 0 ? void 0 : _a.officeId,
                                        projectId: state.projectId,
                                        docType: "comparative-bid-analysis",
                                        docId: state.CBAId,
                                        ref: (_b = state.ref) !== null && _b !== void 0 ? _b : "",
                                        docDesc: state.justificationForSelection,
                                        action: "cancelled",
                                    })];
                                case 1:
                                    _c.sent();
                                    antd_1.message.success(t("alerts.success"));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    break;
                }
                case "Revoke": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.revokeCBA)(state.CBAId, state.orderId, transaction)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: (_a = state.RFQsData[0]) === null || _a === void 0 ? void 0 : _a.officeId,
                                        projectId: state.projectId,
                                        docType: "comparative-bid-analysis",
                                        docId: state.CBAId,
                                        ref: (_b = state.ref) !== null && _b !== void 0 ? _b : "",
                                        docDesc: state.justificationForSelection,
                                        action: "approved",
                                    })];
                                case 1:
                                    _c.sent();
                                    antd_1.message.success(t("alerts.success"));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function () {
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
                case "Publish": {
                    var isValid_1 = true;
                    var CBAData_1 = getCBADataFromState(state);
                    console.log({ CBAData: CBAData_1 });
                    if ((0, doesObjHaveUndefinedValues_1.default)(CBAData_1)) {
                        antd_1.message.error(t("alerts.invalidFormMsg"));
                        return __assign(__assign({}, state), { triedSubmitting: true });
                    }
                    state.CBAItems.map(function (item) {
                        if ((0, doesObjHaveUndefinedValues_1.default)(item)) {
                            antd_1.message.error(t("alerts.invalidFormMsg"));
                            isValid_1 = false;
                            return __assign(__assign({}, state.CBAItems), { triedSubmitting: true });
                        }
                    });
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(0, doesObjHaveUndefinedValues_1.default)(CBAData_1)) {
                                        isValid_1 = true;
                                        transaction.update(collectionsRef_1.CBAsRef.doc(state.CBAId), __assign({}, CBAData_1));
                                    }
                                    state.CBAItems.map(function (item) {
                                        if (!(0, doesObjHaveUndefinedValues_1.default)(item)) {
                                            isValid_1 = true;
                                            transaction.update(collectionsRef_1.CBAItemsRef.doc(item.id), __assign({}, item));
                                        }
                                    });
                                    (0, map_1.default)(state === null || state === void 0 ? void 0 : state.CBARFQItems, function (item) {
                                        var itemData = {
                                            technicalEvaluationMark: item.technicalEvaluationMark,
                                        };
                                        if (!(0, doesObjHaveUndefinedValues_1.default)(itemData)) {
                                            isValid_1 = true;
                                            transaction.update(collectionsRef_1.CBARFQItemsRef.doc(item.id), __assign({}, itemData));
                                        }
                                    });
                                    if (isValid_1 === true) {
                                        transaction.update(collectionsRef_1.CBAsRef.doc(state.CBAId), {
                                            status: "pendingCBAOfficeManagerApproval",
                                            requestedAt: new Date(),
                                            requestedBy: app_1.default.auth().currentUser.uid,
                                        });
                                    }
                                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                                            officeId: (_a = state.RFQsData[0]) === null || _a === void 0 ? void 0 : _a.officeId,
                                            approval: "CBAOfficeManagerApproval",
                                            projectId: state.projectId,
                                            amount: state.RFQsOverallTotals[0],
                                            docId: state.CBAId,
                                            docType: "comparative-bid-analysis",
                                            ref: state.ref,
                                            userId: userId,
                                            docDesc: state.justificationForSelection,
                                            action: "approvalPending",
                                        })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(isValid_1 === true)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, antd_1.message.success(t("alerts.success"))];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        if (isValid_1 === true) {
                            window.location.reload();
                        }
                    })
                        .catch(function (e) {
                        console.error(e);
                        antd_1.message.error("alerts.error");
                    });
                    break;
                }
            }
    }
    return state;
}; };
exports.getCBAReducer = getCBAReducer;
exports.default = exports.getCBAReducer;
var getCBADataFromState = function (state) {
    var _a, _b;
    return {
        orderId: state.orderId,
        status: state.status,
        projectId: state.projectId,
        projectsIds: state.projectsIds,
        initiatedBy: state.initiatedBy,
        ref: state.ref,
        IRId: state.IRId,
        IRref: state.IRref,
        justificationForSelection: state.justificationForSelection,
        budgetLineId: state.budgetLineId,
        currenciesIds: state.currenciesIds,
        currenciesExchangeRates: state.currenciesExchangeRates,
        RFQsTotals: state.RFQsTotals,
        RFQsTaxes: state.RFQsTaxes,
        RFQsIds: state.RFQsIds,
        RFQsShippingCosts: state.RFQsShippingCosts,
        RFQsOverallTotals: state.RFQsOverallTotals,
        preparedByLogistics: (_a = state.preparedByLogistics) !== null && _a !== void 0 ? _a : "",
        CBADate: (_b = state.CBADate) === null || _b === void 0 ? void 0 : _b.toDate(),
    };
};
function checkIfAllApproved(CBAId, orderId, state, userId, approvalType, transaction) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return __awaiter(this, void 0, void 0, function () {
        var waitingFor, productType, selectedSuppliers, total, max, supplierCurrency, totalInProjectCurrency, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    productType = state.CBAItems.map(function (item) {
                        return item.productType;
                    });
                    selectedSuppliers = (0, lodash_1.uniq)((_a = state.CBAItems) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                        var _a, _b, _c;
                        var supplier = (_c = (_b = (_a = state.suppliersData) === null || _a === void 0 ? void 0 : _a.find(function (e) { return (x === null || x === void 0 ? void 0 : x.selectedSupplierId) === e.id; })) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "";
                        return supplier;
                    }));
                    total = (0, lodash_1.flatMap)(selectedSuppliers.map(function (supplierId) {
                        return state.RFQsData.filter(function (RFQItem) {
                            return supplierId === RFQItem.supplierId;
                        });
                    }));
                    max = (0, lodash_1.maxBy)(total, function (x) { return x.overallTotal; });
                    supplierCurrency = (_b = currenciesList_1.globalCurrenciesData[max.currencyId]) === null || _b === void 0 ? void 0 : _b.name;
                    totalInProjectCurrency = supplierCurrency === "Euro (€)"
                        ? max.overallTotal * max.exchangeRate
                        : max.overallTotal / max.exchangeRate;
                    if (!(approvalType === "generalDirector")) return [3 /*break*/, 2];
                    transaction.update(collectionsRef_1.CBAsRef.doc(CBAId), { status: "approved" });
                    if (productType.includes("service")) {
                        transaction.update(collectionsRef_1.ordersRef.doc(orderId), {
                            status: "preparingSC",
                        });
                    }
                    else {
                        transaction.update(collectionsRef_1.ordersRef.doc(orderId), {
                            status: "preparingPOs",
                        });
                    }
                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                            officeId: (_c = state.RFQsData[0]) === null || _c === void 0 ? void 0 : _c.officeId,
                            projectId: state.projectId,
                            docType: "comparative-bid-analysis",
                            docId: CBAId,
                            ref: (_d = state.ref) !== null && _d !== void 0 ? _d : "",
                            docDesc: state.justificationForSelection,
                            action: "approved",
                        })];
                case 1:
                    _o.sent();
                    return [3 /*break*/, 16];
                case 2:
                    if (!(approvalType === "deputyGeneralDirector")) return [3 /*break*/, 6];
                    if (!(1000 > totalInProjectCurrency)) return [3 /*break*/, 4];
                    transaction.update(collectionsRef_1.CBAsRef.doc(CBAId), { status: "approved" });
                    if (productType.includes("service")) {
                        transaction.update(collectionsRef_1.ordersRef.doc(orderId), {
                            status: "preparingSC",
                        });
                    }
                    else {
                        transaction.update(collectionsRef_1.ordersRef.doc(orderId), {
                            status: "preparingPOs",
                        });
                    }
                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                            officeId: (_e = state.RFQsData[0]) === null || _e === void 0 ? void 0 : _e.officeId,
                            projectId: state.projectId,
                            docType: "comparative-bid-analysis",
                            docId: CBAId,
                            ref: (_f = state.ref) !== null && _f !== void 0 ? _f : "",
                            docDesc: state.justificationForSelection,
                            action: "approved",
                        })];
                case 3:
                    _o.sent();
                    return [3 /*break*/, 5];
                case 4:
                    transaction.update(collectionsRef_1.CBAsRef.doc(CBAId), {
                        status: "pendingCBAGeneralDirectorApproval",
                    });
                    waitingFor = "CBAGeneralDirectorApproval";
                    _o.label = 5;
                case 5: return [3 /*break*/, 16];
                case 6:
                    if (!(approvalType === "financeProjectsManager")) return [3 /*break*/, 10];
                    if (!
                    // state.RFQsOverallTotals[0] <= 100
                    (100 >= totalInProjectCurrency)) 
                    // state.RFQsOverallTotals[0] <= 100
                    return [3 /*break*/, 8];
                    transaction.update(collectionsRef_1.CBAsRef.doc(CBAId), { status: "approved" });
                    if (productType.includes("service")) {
                        transaction.update(collectionsRef_1.ordersRef.doc(orderId), {
                            status: "preparingSC",
                        });
                    }
                    else {
                        transaction.update(collectionsRef_1.ordersRef.doc(orderId), {
                            status: "preparingPOs",
                        });
                    }
                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                            officeId: (_g = state.RFQsData[0]) === null || _g === void 0 ? void 0 : _g.officeId,
                            projectId: state.projectId,
                            docType: "comparative-bid-analysis",
                            docId: CBAId,
                            ref: (_h = state.ref) !== null && _h !== void 0 ? _h : "",
                            docDesc: state.justificationForSelection,
                            action: "approved",
                        })];
                case 7:
                    _o.sent();
                    return [3 /*break*/, 9];
                case 8:
                    transaction.update(collectionsRef_1.CBAsRef.doc(CBAId), {
                        status: "pendingCBADeputyGeneralDirectorApproval",
                    });
                    waitingFor = "CBADeputyGeneralDirectorApproval";
                    _o.label = 9;
                case 9: return [3 /*break*/, 16];
                case 10:
                    if (!(approvalType === "logistics")) return [3 /*break*/, 11];
                    transaction.update(collectionsRef_1.CBAsRef.doc(CBAId), {
                        status: "pendingCBAFinanceProjectsManagerApproval",
                    });
                    waitingFor = "CBAFinanceProjectsManagerApproval";
                    return [3 /*break*/, 16];
                case 11:
                    if (!(approvalType === "officeManager")) return [3 /*break*/, 12];
                    transaction.update(collectionsRef_1.CBAsRef.doc(CBAId), {
                        status: "pendingCBALogisticsApproval",
                    });
                    waitingFor = "CBALogisticsApproval";
                    return [3 /*break*/, 16];
                case 12:
                    if (!(((approvalType === "generalDirector" ||
                        approvalType === "deputyGeneralDirector") &&
                        ((_j = projectsList_1.globalProjectsData[state === null || state === void 0 ? void 0 : state.projectId]) === null || _j === void 0 ? void 0 : _j.thresholdForRequiringCBAFifthApproval) > totalInProjectCurrency) ||
                        (approvalType === "financeProjectsManager" &&
                            (state === null || state === void 0 ? void 0 : state.RFQsOverallTotals[0]) <= 100))) return [3 /*break*/, 13];
                    _m = null;
                    return [3 /*break*/, 15];
                case 13: return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                        officeId: (_k = state === null || state === void 0 ? void 0 : state.RFQsData[0]) === null || _k === void 0 ? void 0 : _k.officeId,
                        approval: waitingFor,
                        projectId: state === null || state === void 0 ? void 0 : state.projectId,
                        amount: state === null || state === void 0 ? void 0 : state.RFQsOverallTotals[0],
                        docId: CBAId,
                        docType: "comparative-bid-analysis",
                        ref: state === null || state === void 0 ? void 0 : state.ref,
                        userId: state === null || state === void 0 ? void 0 : state.requestedBy,
                        docDesc: state === null || state === void 0 ? void 0 : state.justificationForSelection,
                        action: "approvalPending",
                    })];
                case 14:
                    _m = _o.sent();
                    _o.label = 15;
                case 15:
                    _m;
                    console.log((_l = state.RFQsData[0]) === null || _l === void 0 ? void 0 : _l.officeId, waitingFor, state.projectId, state.RFQsOverallTotals[0], CBAId, state.ref, state.requestedBy, state.justificationForSelection);
                    _o.label = 16;
                case 16: return [2 /*return*/];
            }
        });
    });
}
function checkNextStatus(state, approvalType) {
    var _a, _b;
    var status;
    var selectedSuppliers = (0, lodash_1.uniq)((_a = state.CBAItems) === null || _a === void 0 ? void 0 : _a.map(function (x) {
        var _a, _b, _c;
        var supplier = (_c = (_b = (_a = state.suppliersData) === null || _a === void 0 ? void 0 : _a.find(function (e) { return (x === null || x === void 0 ? void 0 : x.selectedSupplierId) === e.id; })) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "";
        return supplier;
    }));
    var total = (0, lodash_1.flatMap)(selectedSuppliers.map(function (supplierId) {
        return state.RFQsData.filter(function (RFQItem) {
            return supplierId === RFQItem.supplierId;
        });
    }));
    var max = (0, lodash_1.maxBy)(total, function (x) { return x.overallTotal; });
    var supplierCurrency = (_b = currenciesList_1.globalCurrenciesData[max.currencyId]) === null || _b === void 0 ? void 0 : _b.name;
    var totalInProjectCurrency = supplierCurrency === "Euro (€)"
        ? max.overallTotal * max.exchangeRate
        : max.overallTotal / max.exchangeRate;
    if (approvalType === "generalDirector") {
        status = "approved";
    }
    else if (approvalType === "deputyGeneralDirector") {
        if (1000 > totalInProjectCurrency) {
            status = "approved";
        }
        else {
            status = "pendingCBAGeneralDirectorApproval";
        }
    }
    else if (approvalType === "financeProjectsManager") {
        console.log(state.RFQsOverallTotals[0]);
        if (100 >= totalInProjectCurrency
        // state.RFQsOverallTotals[0] <= 100
        ) {
            status = "approved";
        }
        else {
            status = "pendingCBADeputyGeneralDirectorApproval";
        }
    }
    else if (approvalType === "logistics") {
        status = "pendingCBAFinanceProjectsManagerApproval";
    }
    else if (approvalType === "officeManager") {
        status = "pendingCBALogisticsApproval";
    }
    else {
        status = "";
    }
    return status;
}
var revokeCBA = function (CBAId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, POs, someCompleted, itemsReceived;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                userId = (_b = (_a = app_1.default.auth().currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : "";
                return [4 /*yield*/, collectionsRef_1.POsRef.where("CBAId", "==", CBAId).get()];
            case 1:
                POs = (_d = (_c = (_e.sent())) === null || _c === void 0 ? void 0 : _c.docs) !== null && _d !== void 0 ? _d : [];
                someCompleted = POs.some(function (x) {
                    var data = x.data();
                    return data.status === "singedAndArchived" || data.status === "completed";
                });
                if (someCompleted) {
                    throw new Error("alerts.youCannotRevokeSingedForm");
                }
                return [4 /*yield*/, collectionsRef_1.DNsRef.where("orderId", "==", orderId).get()];
            case 2:
                itemsReceived = (_e.sent())
                    .docs.length;
                if (itemsReceived) {
                    throw new Error("This CBA has Delivery Note and cannot be revoked");
                }
                POs.map(function (PO) { return (0, POReducer_1.deletePO)(PO.id, orderId, transaction); });
                collectionsRef_1.CBAsRef.doc(CBAId).update({
                    status: "draft",
                    requestedAt: app_1.default.firestore.FieldValue.delete(),
                    requestedBy: app_1.default.firestore.FieldValue.delete(),
                }), transaction.update(collectionsRef_1.ordersRef.doc(orderId), { status: "preparingCBA" });
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where("formId", "==", CBAId).get()];
            case 3:
                (_e.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where("docId", "==", CBAId).get()];
            case 4:
                (_e.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [2 /*return*/];
        }
    });
}); };
exports.revokeCBA = revokeCBA;
var deleteCBA = function (CBAId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, transaction.get(collectionsRef_1.CBAsRef.doc(CBAId))];
            case 1:
                data = (_c.sent()).data();
                if (data.status === "singedAndArchived" || data.status === "completed") {
                    throw new Error("alerts.youCannotDeleteSingedForm");
                }
                if (data.status === "pendingApprovals" || data.status === "approved") {
                    (0, exports.revokeCBA)(CBAId, orderId, transaction);
                }
                transaction.delete(collectionsRef_1.CBAsRef.doc(CBAId));
                return [4 /*yield*/, ((_a = collectionsRef_1.CBAItemsRef.where("CBAId", "==", CBAId)) === null || _a === void 0 ? void 0 : _a.get())];
            case 2:
                (_c.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [4 /*yield*/, ((_b = collectionsRef_1.CBARFQItemsRef.where("CBAId", "==", CBAId)) === null || _b === void 0 ? void 0 : _b.get())];
            case 3:
                (_c.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [2 /*return*/];
        }
    });
}); };
exports.deleteCBA = deleteCBA;
